const ALL_LANGUAGES = [
    { code: 'en',    name: 'English',  native: 'English'   },
    { code: 'ru',    name: 'Russian',  native: 'Русский'   },
    { code: 'fr',    name: 'French',   native: 'Français'  },
    { code: 'es',    name: 'Spanish',  native: 'Español'   },
    { code: 'de',    name: 'German',   native: 'Deutsch'   },
    { code: 'zh-CN', name: 'Chinese',  native: '中文'       },
    { code: 'ar',    name: 'Arabic',   native: 'العربية'   },
];

// Pre-init lookup tables — shared with the inline IIFE to prevent blank flash on reload
const LANG_NAMES = Object.fromEntries(ALL_LANGUAGES.map(l => [l.code, l.name]));
const LANG_CODES = Object.fromEntries(ALL_LANGUAGES.map(l => [
    l.code,
    l.code === 'zh-CN' ? 'ZH' : l.code.toUpperCase().slice(0, 2)
]));

function createLanguageSwitcher(config = {}) {
    const enabledCodes = config.enabledCodes?.length
        ? config.enabledCodes
        : ALL_LANGUAGES.map(l => l.code);

    const languages = ALL_LANGUAGES.filter(l => enabledCodes.includes(l.code));
    const defaultLang = config.defaultLang || 'en';
    const instanceId  = config.instanceId  || '';

    return {
        isOpen: false,
        currentLanguage: siteStorage.get('selected_language') || defaultLang,
        languages,
        instanceId,

        init() {
            window.addEventListener('language-changed',  (e) => { this.currentLanguage = e.detail.language; });
            window.addEventListener('language-switched', (e) => { this.currentLanguage = e.detail.language; });
        },

        switchLanguage(langCode) {
            this.currentLanguage = langCode;
            siteStorage.set('selected_language', langCode);
            window.dispatchEvent(new CustomEvent('language-changed', { detail: { language: langCode } }));
            this.isOpen = false;
        },

        getCurrentLanguageName() {
            return LANG_NAMES[this.currentLanguage] || 'Language';
        },

        getCurrentLanguageCode() {
            return LANG_CODES[this.currentLanguage] || 'EN';
        },

        isActive(langCode) {
            return this.currentLanguage === langCode;
        }
    };
}

window.createLanguageSwitcher = createLanguageSwitcher;
window.LANG_NAMES = LANG_NAMES;
window.LANG_CODES = LANG_CODES;
